import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, CardHeader, Col, Row, FormGroup, Form } from 'reactstrap';
import InputGroup from '../../../components/cms/form/inputGroup';
import SubmitButtons from '../../../components/cms/form/submitButtons';
import InputFile from '../../../components/cms/form/inputFile';
import PreviewImage from '../../../components/previewImage';
import dh from '../../../helpers/date.helper';
import { Link } from 'react-router-dom';

const Item = ({
  t,
  onChange,
  onSubmit,
  errors,
  formData,
  title,
  tab,
  companiesList,
  typesList,
  isSubmitting,
  isSubmittingRedirect,
  imageSrc,
}) => (
  <div>
    <Row>
      <Col md={12}>
        <Card>
          <CardHeader>
            <strong><i className="fa fa-font pr-2" />{title}</strong>
          </CardHeader>
          <CardBody>
            <Form onSubmit={onSubmit(true)}>
              <Row>
                <Col md={9}>
                  <InputGroup
                    name="title"
                    label={t('Title')}
                    onChange={onChange}
                    errors={errors}
                    value={formData.title}
                    icon="fa fa-star"
                  />
                  <InputGroup
                    type="textarea"
                    name="content"
                    label={t('Content')}
                    onChange={onChange}
                    errors={errors}
                    value={formData.content}
                    rows={10}
                  />
                  <InputGroup
                    name="type"
                    type="select"
                    label={t('Type')}
                    onChange={onChange}
                    errors={errors}
                    options={typesList}
                    value={formData.type}
                    icon="fa fa-link"
                  />
                  {formData.type == 3 && (
                    <InputGroup
                      label={t('Companies')}
                      name="companiesList"
                      type="select2"
                      onChange={onChange}
                      errors={errors}
                      value={formData.companiesList}
                      options={companiesList}
                      empty="-"
                      icon="fa fa-star"
                      isMulti
                    />
                  )}
                </Col>
                <Col md={3}>
                  <div className="">
                    {/*<InputFile id="image">*/}
                      {/*<PreviewImage src={imageSrc} className="" alt="img" height="120" />*/}
                    {/*</InputFile>*/}
                    <InputGroup
                      name="status"
                      label={t('Status')}
                      onChange={onChange}
                      errors={errors}
                      type="checkbox"
                      value={1}
                      checked={formData.status}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <SubmitButtons
                    isSubmitting={isSubmitting}
                    onSubmit={onSubmit}
                    isSubmittingRedirect={isSubmittingRedirect}
                  />
                </Col>
              </Row>

                { formData.id && !!formData.stats.clicks.length && (
                  <Row>
                    <Col md={12}>
                      <h4>{t('Clicks')} <span className="badge badge-secondary">{formData.stats.clicks.length}</span></h4>
                      <ul className="list-group">
                        { formData.stats.clicks.map(item => (<li className="list-group-item">
                          <small>{dh.getFormattedDate(item.created_at)}</small>
                          <Link to={"/users/" + item.user_id}> {item.email}</Link>
                          <span> </span>
                           (<Link to={"/users/companies/" + item.company_id}>{item.company_title}</Link>)
                        </li>))}
                      </ul>
                    </Col>
                  </Row>
                )}

            </Form>
          </CardBody>
        </Card>
      </Col>
    </Row>

  </div>
);

Item.propTypes = {
  t: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  isSubmittingRedirect: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  formData: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  imageSrc: PropTypes.string.isRequired,
};

export default Item;



// WEBPACK FOOTER //
// ./src/views/notifications/item/Item.jsx